var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-wrapper"},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.vendorList,"fields":_vm.fields},on:{"row-clicked":_vm.goToVendor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }